import Vue from 'vue'
import { ISocketPayload } from '@/system/socket/store'
import { IJobId } from '@/features/job/store'
import {
  REMOVE_JOB,
  FETCH_JOB_LIST_ACTION,
  CREATE_JOB_ACTION,
  FETCH_JOB_BY_ID_ACTION
} from '@/system/store/action-types'

export default class JobService extends Vue {
  public async deleteJob (payload: ISocketPayload<IJobId> = {}): Promise<void> {
    const action = REMOVE_JOB
    this.$socket.sendObj({ action, ...payload })
  }

  public fetchJobList (payload: ISocketPayload = {}): void {
    const action = FETCH_JOB_LIST_ACTION
    this.$socket.sendObj({ action, ...payload })
  }

  public fetchJobById (payload: ISocketPayload<IJobId> = {}): void {
    const action = FETCH_JOB_BY_ID_ACTION
    this.$socket.sendObj({ action, ...payload })
  }

  public createJob (payload: ISocketPayload = {}): void {
    const action = CREATE_JOB_ACTION
    this.$socket.sendObj({ action, ...payload })
  }
}
